import * as ko from "knockout";
function NodeViewModel(text, level, data, id, openUrl, root) {
    var self = this;
    self.Text = text;
    self.GridNodes = ko.observableArray([]);
    self.HasNodes = ko.computed(function () {
        return self.GridNodes().length > 0;
    });
    self.Opened = ko.observable(false);
    self.RootOpened = ko.observable(false);
    self.RootOpened.subscribe(function () {
        $.each(self.GridNodes(), function (index, node) {
            node.RootOpened(self.RootOpened());
        });
    });
    self.Opened.subscribe(function () {
        $.each(self.GridNodes(), function (index, node) {
            node.RootOpened(self.Opened());
        });
    });
    self.Level = level;
    self.Data = data;
    self.Loaded = ko.observable(false);
    self.Id = id;
    self.OpenData = id;
    self.OpenUrl = openUrl;
    self.Root = root;
    self.Icon = ko.computed(function () {
        if (self.Opened() && self.HasNodes()) {
            return "fa-minus-square";
        }
        else if (!self.Opened() && !self.Loaded() || !self.Opened() && self.Loaded() && self.HasNodes()) {
            return "fa-plus-square";
        }
        else {
            return "";
        }
    });
}
export default NodeViewModel;